import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable, inject } from '@angular/core';
import { mergeMap, withLatestFrom } from 'rxjs/operators';

import { Observable } from 'rxjs';
import { OrdAllocateActions } from '../ord-allocate/ord-allocate.actions';
import { OrdDeAllocateMultipleActions } from '../ord-deallocate-multiple/ord-deallocate-multiple.actions';
import { OrdDeAllocateSingleActions } from '../ord-deallocate-single/ord-deallocate-single.actions';
import { OrdFilterEnum } from '../ord-filters/models/ord-filters.enum';
import { OrdFilterGroupEnum } from '../ord-filters/models/ord-filter-group.enum';
import { OrdFiltersActions } from '../ord-filters/ord-filters.actions';
import { OrdMultiAllocateActions } from './ord-multi-allocate.actions';
import { Store } from '@ngrx/store';
import { ordFilterConstants } from '../ord-filters/models/ord-filter-constants';
import ordMultiAllocateReducer from './ord-multi-allocate.reducer';

@Injectable()
export class OrdMultiAllocateEffects {
    private readonly actions$ = inject(Actions);
    private readonly appStore = inject(Store);

    afterEnd$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(OrdMultiAllocateActions.end),
        mergeMap((_action) => [
            OrdDeAllocateMultipleActions.load({}),
            OrdFiltersActions.updateSingleFilter({
                filterGroup: {...ordFilterConstants.find(f => f.key === OrdFilterGroupEnum.ordAllocated), isActive: false, value: null }
            }),
        ]))
    );

    afterAllocate$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(OrdMultiAllocateActions.allocate),
        mergeMap((action) => [
            OrdAllocateActions.load({
                query: {
                    force: action.force,
                    isMultiAllocate: true,
                    refreshOrders: true,
                    order: action.order,
                }
            })
        ]))
    );

    afterDeallocate$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(OrdMultiAllocateActions.deAllocate),
        mergeMap((action) => [
            OrdDeAllocateSingleActions.load({
                query: {
                    force: true,
                    isMultiAllocate: true,
                    refreshOrders: true,
                    order: action.order,
                }
            })
        ]))
    );

    afterToggleOnlyMine$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(OrdMultiAllocateActions.toggleFilter),
        withLatestFrom(this.appStore.select(ordMultiAllocateReducer.selectShowOnlyMine), this.appStore.select(ordMultiAllocateReducer.selectShowOnlyMine)),
        mergeMap(([action, showOnlyMine]) => [
            OrdFiltersActions.updateSingleFilter({
                filterGroup: {...ordFilterConstants.find(f => f.key === OrdFilterGroupEnum.ordAllocated), isActive: true, value: showOnlyMine ? OrdFilterEnum.ordAlloctedOnlyMine : null }
            }),
        ]))
    );

}
